import { useEffect, useState } from "react";
import { Disclosure } from "@headlessui/react";
import { Link as NavBarLink, useLocation, useNavigate } from "react-router-dom";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import Logo from "../../images/logo.png";
import BarIcon from "../../images/bar-icon.png";
import Button from "../button";
import { Link, animateScroll as scroll } from "react-scroll";
import ReactGA from "react-ga4";
import { handleEventAnalytics } from "../../utilities/eventAnalytics";
import { trackCustomEvent } from "../../FacebookPixel";

export default function Navbar() {
  const [showButton, setShowButton] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleProfessionalSignUp = () => {
    navigate("/signup/step/1");
  };

  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector("nav");

      if (header) {
        const scrollPosition = window.scrollY;

        if (scrollPosition > 50) {
          header.classList.add("bg-color-change");
        } else {
          header.classList.remove("bg-color-change");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const banner = document.getElementById("banner"); // Replace 'banner' with your banner's id
      const bannerBottom = banner?.getBoundingClientRect().bottom;
      const scrolled = window.scrollY;

      // Show the button if scrolled below a certain distance from the banner's bottom
      if (scrolled > bannerBottom + 500) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    ReactGA.event(handleEventAnalytics("match_button_fold"));
    trackCustomEvent("Find My Match Button", {});
    const options = {
      duration: 0,
      smooth: true,
    };
    scroll.scrollToTop(options);
    setShowButton(false);
  };

  const handleClick = (platform) => {
    ReactGA.event(handleEventAnalytics(platform));
    trackCustomEvent(platform, {});
  };

  const handleProviderClick = (platform) => {
    ReactGA.event(handleEventAnalytics(platform));
    trackCustomEvent(platform, {});
    navigate("/signup/step/1");
  };

  return (
    <Disclosure
      as="nav"
      className="main-header fixed left-0 top-0 z-10 w-full transition-all"
    >
      {({ open, close }) => (
        <>
          <div className="sm:py-5 container">
            <div className="flex h-16 items-center justify-between">
              <div className="flex items-center">
                <Link
                  to="/"
                  className="flex-shrink-0 lg:mr-12 xl:mr-32 inline-block cursor-pointer"
                >
                  <img
                    className="w-auto h-8 sm:h-11"
                    src={Logo}
                    alt="HelpMatch Logo"
                  />
                </Link>
                <div className="hidden sm:ml-6 lg:block">
                  <div className="flex space-x-4 desktop-nav">
                    {/* Current: "bg-gray-900 text-white", Default: "text-gray-300 hover:bg-gray-700 hover:text-white" */}
                    <Link
                      to="why-helpMatch"
                      spy={true}
                      offset={-120}
                      className="xl:px-3 py-2 text-base xl:text-lg font-medium text-customGray hover:text-primary cursor-pointer capitalize"
                    >
                      Why HelpMatch?
                    </Link>
                    <Link
                      to="how-helpMatch"
                      spy={true}
                      offset={-120}
                      className="rounded-md xl:px-3 py-2 text-base xl:text-lg font-medium ext-customGray hover:text-primary cursor-pointer capitalize"
                    >
                      How It Works
                    </Link>
                    <Link
                      to="say-helpMatch"
                      spy={true}
                      offset={-120}
                      className="rounded-md xl:px-3 py-2 text-base xl:text-lg font-medium ext-customGray hover:text-primary cursor-pointer capitalize"
                    >
                      What others Say
                    </Link>
                    {/* <NavBarLink
                      to="/signup/step/1"
                      className="rounded-md xl:px-3 py-2 text-base xl:text-lg font-medium ext-customGray hover:text-primary cursor-pointer"
                      onClick={() => handleClick("enroll_as_provider")}
                    >
                      Enroll as a Provider
                    </NavBarLink> */}
                  </div>
                </div>
              </div>
              <div className="hidden sm:ml-6 items-center sm:flex sm:gap-5">
                {/* <Button
                  title="SIGN UP"
                  classes="px-8 py-4 text-customGray bg-white rounded-xl border font-black"
                  onClick={handleSignUp}
                /> */}
                <NavBarLink
                  to="/signin"
                  className="rounded-md xl:px-3 py-2 text-sm font-bold text-customGray hover:text-primary cursor-pointer uppercase leading-[160%]"
                >
                  sign in
                </NavBarLink>
                <Button
                  title="Join as a provider "
                  classes="px-[30px] py-4 bg-primary text-sm text-white rounded-xl font-black duration-500 hover:bg-[#026ed6] uppercase"
                  onClick={() => handleProviderClick("enroll_as_provider")}
                />
                {/* {showButton && (
                  <Button
                    title="get matched now"
                    classes="px-8 py-4 bg-primary text-white rounded-xl font-black duration-500 hover:bg-[#026ed6] capitalize"
                    onClick={scrollToTop}
                  />
                )} */}
              </div>
              <div className="-mr-2 flex sm:hidden">
                {/* Mobile menu button */}
                <Disclosure.Button className="relative inline-flex items-center justify-center rounded-md p-2 text-primary">
                  <span className="absolute -inset-0.5" />
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    // <Bars3Icon className="block h-6 w-6 text-primary" aria-hidden="true" />
                    <div
                      className="relative lg:hidden"
                      data-headlessui-state=""
                    >
                      <button
                        className=""
                        type="button"
                        aria-expanded="false"
                        data-headlessui-state=""
                        id="headlessui-popover-button-:r0:"
                      >
                        <img src={BarIcon} alt="" />
                      </button>
                    </div>
                  )}
                </Disclosure.Button>
              </div>
            </div>
          </div>

          <Disclosure.Panel className="sm:hidden">
            <div className="space-y-1 px-2 pb-3 pt-5 bg-[rgb(255,255,255)] h-[100vh] mobile-nav">
              {/* Current: "bg-gray-900 text-white", Default: "text-gray-300 hover:bg-gray-700 hover:text-white" */}
              <Link
                to="why-helpMatch"
                spy={true}
                offset={-120}
                className="block rounded-md px-3 py-2 text-base font-medium text-customGray capitalize"
                onClick={() => close()}
              >
                Why HelpMatch?
              </Link>
              <Link
                to="how-helpMatch"
                spy={true}
                offset={-120}
                className="block rounded-md px-3 py-2 text-base font-medium text-customGray capitalize"
                onClick={() => close()}
              >
                How It Works
              </Link>
              <Link
                to="say-helpMatch"
                spy={true}
                offset={-120}
                className="block rounded-md px-3 py-2 text-base font-medium text-customGray capitalize"
                onClick={() => close()}
              >
                What others Say
              </Link>
              <div className="flex flex-col gap-3 px-3">
                <NavBarLink
                  to="/signin"
                  className="block rounded-md py-2 text-base font-medium text-customGray capitalize"
                >
                  sign in
                </NavBarLink>
                <Button
                  title="Join as a provider "
                  classes="px-[30px] py-4 bg-primary text-sm text-white rounded-xl font-black duration-500 hover:bg-[#026ed6] uppercase"
                  onClick={() => handleProviderClick("enroll_as_provider")}
                />
              </div>
            </div>
          </Disclosure.Panel>
          {/* <NavBarLink
                to="/signup/step/1"
                className="block rounded-md px-3 py-2 text-base font-medium text-customGray"
                onClick={() => handleClick("enroll_as_provider")}
              >
                What other Says
              </NavBarLink> */}
        </>
      )}
    </Disclosure>
  );
}
